import { Button } from '@palmetto/palmetto-components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { SalesRepStatus, salesRepStatusLabels } from 'types';

import { isSalesRepLicenseManagedByRecheck } from '../../../helpers/salesRepRecheck';
import { GetSalesRepAuthLinkModal } from '../../SalesRepVerification/GetSalesRepAuthLinkModal';
import { RecheckLicenseLink } from '../../SalesRepVerification/RecheckLicenseLink';

import { useAccountDetailsContext } from './AccountDetailsContext';

interface UseSalesRepPropertiesParams {
  shouldVerifySalesRep: boolean;
}

export function useSalesRepProperties({ shouldVerifySalesRep }: UseSalesRepPropertiesParams) {
  const { account, id, isAccountEditEnabled, openModal } = useAccountDetailsContext();
  const { salesRepRecheckBeforeContract } = useFlags();

  const showRecheckLicenseLink =
    !account?.salesRepLicenseNumber &&
    isSalesRepLicenseManagedByRecheck(account?.address?.state, account?.programType, salesRepRecheckBeforeContract);

  return {
    heading: 'Sales Rep',
    editPath: isAccountEditEnabled ? `/accounts/${id}/edit` : undefined,
    values: [
      { label: 'Name', value: account?.salesRepName },
      {
        label: 'License',
        value: showRecheckLicenseLink ? <RecheckLicenseLink /> : account?.salesRepLicenseNumber,
      },
      { label: 'Email', value: account?.salesRepEmail },
      { label: 'Phone', value: account?.salesRepPhoneNumber },
      ...(shouldVerifySalesRep
        ? [
            {
              label: 'Sales Rep Status',
              value: account?.salesRepVerification?.status ? (
                <Button variant="primary" tone="neutral" size="xs" onClick={() => openModal('reCheck')}>
                  {salesRepStatusLabels[account?.salesRepVerification?.status as SalesRepStatus]?.toUpperCase()}
                </Button>
              ) : (
                <GetSalesRepAuthLinkModal />
              ),
            },
          ]
        : []),
    ],
  };
}
